<!-- Modern Revenue Filters with Vertical Layout -->
<div class="revenue-filters modern-filters" [class.drawer-mode]="drawerMode">
  <!-- Header with Filters title -->
  <div class="filters-header-main" [ngClass]="drawerMode ? 'p-3' : 'mb-3'">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [ngClass]="drawerMode ? 'drawer-scroll' : 'default-scroll'"
  >
    <!-- Date Range Section -->
    <div
      class="filter-section date-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Date Range</h3>
      </div>

      <div class="date-filter-group mb-3">
        <label class="filter-label">Select Date Range</label>
        <p-datepicker
          #dateRangePicker
          [formControl]="formGroup.controls.dateRange"
          selectionMode="range"
          [showIcon]="true"
          [showClear]="
            formGroup.controls.dateRange.value &&
            formGroup.controls.dateRange.value.length > 0
          "
          [maxDate]="maxDate"
          placeholder="Select date range"
          dateFormat="mm/dd/yy"
          [readonlyInput]="true"
          (onSelect)="onDateSelect()"
          class="w-full"
          appendTo="body"
          styleClass="w-full"
        />
      </div>

      <!-- Compare to - Auto-populated from API, read-only -->
      <div class="date-filter-group mb-3">
        <label class="filter-label">Compare To</label>

        <!-- Skeleton loader while API is loading -->
        <div *ngIf="isLoading" class="compare-to-skeleton">
          <p-skeleton height="2.5rem" borderRadius="6px" />
          <small class="text-muted mt-1 block text-xs">
            Loading comparison period...
          </small>
        </div>

        <!-- Actual date picker when data is loaded -->
        <ng-container *ngIf="!isLoading">
          <p-datepicker
            [formControl]="formGroup.controls.compareTo"
            selectionMode="range"
            [showIcon]="true"
            placeholder="Previous period"
            dateFormat="mm/dd/yy"
            [disabled]="true"
            [readonlyInput]="true"
            class="w-full compare-to-readonly"
            appendTo="body"
            styleClass="w-full"
          />
          <small class="text-muted mt-1 block text-xs">
            Based on selected date range
          </small>
        </ng-container>
      </div>
    </div>

    <!-- Currency Section -->
    <div
      class="filter-section display-section"
      [ngClass]="drawerMode ? 'px-3 pb-4' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Currency</h3>
      </div>

      <div class="filter-group-vertical mb-3">
        <label class="filter-label">Display Currency</label>
        <p-select
          [formControl]="formGroup.controls.currency"
          [options]="currencies"
          optionValue="code"
          [filter]="true"
          filterBy="code,name"
          filterPlaceholder="Search currency..."
          placeholder="Select currency"
          styleClass="w-full"
          appendTo="body"
        >
          <ng-template pTemplate="selectedItem" let-currency>
            @if (currency) {
              <span>{{ currency.code }} - {{ currency.name }}</span>
            }
          </ng-template>
          <ng-template pTemplate="item" let-currency>
            <span>{{ currency.code }} - {{ currency.name }}</span>
          </ng-template>
        </p-select>
        <small class="text-muted mt-1 block text-xs">
          Default: {{ defaultCurrency }}
        </small>
      </div>
    </div>
  </div>
</div>
